<template>
  <div class="destination-section">
    <div class="dest-section-head">
      <div class="dest-section-label wow animate__fadeInUp">
        {{ sectionLabel }}
      </div>
      <h2
        class="dest-section-title wow animate__fadeInUp"
        data-wow-delay="0.1s"
      >
        {{ sectionTitle }}
      </h2>
    </div>
    <div class="dest-list">
      <router-link
        :to="'/destination/' + item.key"
        class="dest-card wow animate__fadeInUp"
        v-for="(item, index) in displayList"
        :key="item.key"
        :data-wow-delay="
          index > 0 ? Math.min(index * 0.08, 0.5) + 's' : undefined
        "
      >
        <div class="dest-card-img-wrap">
          <img :src="item.img" class="dest-card-img" :alt="item.location" />
        </div>
        <div class="dest-card-body">
          <div class="dest-tour-name">{{ item.tourName }}</div>
          <div class="dest-location">
            <i class="el-icon-location-outline"></i>
            <span>{{ item.location }}</span>
          </div>
          <div class="dest-rating">
            <i class="el-icon-star-on"></i>
            <span>{{ item.rating }} {{ $t("home.enjoy.ratingLabel") }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { DEST_IMGS } from "@/utils/destinationAssets";

export default {
  name: "DestinationSection",
  props: {
    destinationIds: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    sectionLabel() {
      return this.label || this.$t("home.enjoy.en");
    },
    sectionTitle() {
      return this.title || this.$t("home.enjoy.title");
    },
    allDestinations() {
      const items = this.$t("home.enjoy.destinations");
      return items.map((item, index) => ({
        key: index,
        img: DEST_IMGS[index],
        tourName: item.tourName,
        location: item.location,
        rating: item.rating,
      }));
    },
    displayList() {
      if (!this.destinationIds || !this.destinationIds.length) {
        return this.allDestinations;
      }
      const idSet = new Set(this.destinationIds);
      return this.allDestinations.filter((item) => idSet.has(item.key));
    },
  },
};
</script>

<style lang="scss" scoped>
.destination-section {
  padding: 80px 0 100px;
  background-color: $box-bg;
}

.dest-section-head {
  max-width: 1200px;
  margin: 0 auto 48px;
  padding: 0 40px;
  text-align: center;
  box-sizing: border-box;
}

.dest-section-label {
  font-size: 16px;
  font-weight: 500;
  color: #fdc44b;
  letter-spacing: 0.5px;
  margin-bottom: 16px;
}

.dest-section-title {
  margin: 0;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  color: #1a1a1a;
}

.dest-list {
  width: 1200px;
  max-width: calc(100% - 80px);
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.dest-card {
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-height: 400px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }
}

.dest-card-img-wrap {
  overflow: hidden;
  border-radius: 12px 12px 0 0;
  aspect-ratio: 4 / 5;
}

.dest-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.dest-card-body {
  flex-shrink: 0;
  padding: 18px 16px 22px;
}

.dest-tour-name {
  margin-bottom: 12px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  color: #333;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dest-location {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #fdc44b;
  line-height: 1.3;

  i {
    margin-right: 6px;
    font-size: 16px;
  }
}

.dest-rating {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #888;

  i {
    margin-right: 6px;
    font-size: 14px;
    color: #fdc44b;
  }
}

@media (max-width: 1200px) {
  .dest-list {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .dest-section-title {
    font-size: 26px;
  }

  .dest-section-label {
    font-size: 14px;
  }

  .dest-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .dest-list {
    grid-template-columns: 1fr;
  }

  .dest-card {
    min-height: auto;
  }

  .dest-card-img-wrap {
    aspect-ratio: 16 / 11;
  }
}
</style>
